import { gql } from '@apollo/client';

/**
 * Listado del catálogo. Devuelve ACTIVAS E INACTIVAS a propósito:
 *
 * - El módulo de Gestión necesita las dos listas.
 * - El filtro "por empresa" de la tabla de Validaciones tiene que poder filtrar
 *   por una empresa retirada (sus actuaciones antiguas siguen existiendo).
 *
 * Quien solo deba OFRECER empresas seleccionables —el desplegable del wizard de
 * Actuación— filtra por `isActive` en el consumidor.
 */
export const FETCH_EXTERNAL_COMPANIES = gql`
  query GetExternalCompanies {
    externalCompanies {
      id
      companyName
      isActive
      externalWorksCount
    }
  }
`;

export const GET_EXTERNAL_COMPANY_BY_ID = gql`
  query GetExternalCompanyById($id: ID!) {
    externalCompany(id: $id) {
      id
      companyName
      externalWorkIDs
    }
  }
`;

// Warm-up batch para los selectors de tabla. MISMOS campos que
// GET_EXTERNAL_COMPANY_BY_ID: un campo de diferencia = cache miss per-row.
export const EXTERNAL_COMPANIES_BY_IDS_WARMUP = gql`
  query ExternalCompaniesByIds($ids: [ID!]!) {
    externalCompaniesByIds(ids: $ids) {
      id
      companyName
      externalWorkIDs
    }
  }
`;

export const GET_EXTERNAL_COMPANIES = gql`
  query GetExternalCompaniesClient {
    readExternalCompanies @client {
      id
      companyName
    }
  }
`;
